import { render, staticRenderFns } from "./ResumeReduce.vue?vue&type=template&id=6e10b958&scoped=true&"
import script from "./ResumeReduce.vue?vue&type=script&lang=js&"
export * from "./ResumeReduce.vue?vue&type=script&lang=js&"
import style0 from "./ResumeReduce.vue?vue&type=style&index=0&id=6e10b958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e10b958",
  null
  
)

export default component.exports